module.exports = __webpack_public_path__ + "media/images/lp/1/plight4-pc-f63ccd285eb60f7b0001fee07a492126.png";